<span class="relative bg-t1/10 font-inherit">
  <slot />
</span>
